import React, { FC } from 'react'
import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'
import { CardGreyHeadline, CardOutlined, CardOutlinedInner } from 'components/Card'
import { Spacer } from 'components/Utility'
import { parseDateToDeadline, parseTimeToDeadline } from 'lib/helper'

type Props = {
  storeDeliveryBread: StoreDeliveryBreadType
}

const StoreDeliveryBreadCard: FC<Props> = (props) => {
  const { storeDeliveryBread } = props
  // 当日の00:00を起点に、何日前のHH:mmが締切なのか計算する
  const hoursToDeadline = storeDeliveryBread.hours_to_deadline
  const deadlineDate = parseDateToDeadline(hoursToDeadline) // n日前を求める
  const deadlineTime = parseTimeToDeadline(hoursToDeadline) // 締切時間(HH:mm)を求める
  return (
    <CardOutlined>
      <CardGreyHeadline headline={'注文締め切り'} isTop={true} />
      <Spacer size={8} />
      <CardOutlinedInner>
        {deadlineDate === '0' ? '当日' : `${deadlineDate}日前`}&nbsp;{deadlineTime}
      </CardOutlinedInner>
      <Spacer size={8} />
      <CardGreyHeadline headline={'1日の販売上限数'} />
      <Spacer size={8} />
      <CardOutlinedInner>{storeDeliveryBread.maximum_order}個</CardOutlinedInner>
      <Spacer size={8} />
    </CardOutlined>
  )
}

export default StoreDeliveryBreadCard
